import axios from 'axios';
import { Toast } from 'vant';
import { objectToUrlParams } from '@/utils/index';
import { IS_MOCK_KEY } from '@/utils/const';

// create an axios instance
const service = axios.create({
  withCredentials: false,
  'Content-Type': 'application/json',
  timeout: 15 * 1000, // request timeout
});
let isMock = false;

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.headers = config.headers || {};
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    isMock = window.sessionStorage.getItem(IS_MOCK_KEY);
    if (isMock) {
      // 获取请求路径
      const url = response.config.url;
      // 匹配路径对应mock数据
      let urlStr = url.split('/api')[1];
      urlStr +=
        response.config.method === 'get'
          ? objectToUrlParams(response.config.params || {})
          : objectToUrlParams(response.config.data || {});
      const mockData = window.mockDataObj[urlStr];
      if (mockData) {
        // 如果有mock文件，则返回模拟数据
        return Promise.resolve({
          ...mockData,
        });
      } else if (urlStr.includes('/basic-ibms/parking/parkingStat')) {
        // 车行数据单独处理
        const resultData = window.mockDataObj['/basic-ibms/parking/parkingStat'](response.config);
        return Promise.resolve({
          ...resultData,
        });
      }
    }
    return response.data;
  },
  error => {
    console.error('error', error);
    const {
      response: { data, status },
    } = error;
    if (status >= 400 && status <= 499) {
      Toast.fail({
        message: data.msg || '请求异常，请稍后重试',
        duration: 3000,
      });
    } else {
      Toast.fail({
        message: '请求异常，请稍后重试',
        duration: 3000,
      });
    }
    return Promise.reject(error);
  }
);

export default service;
